/* src/app/components/circular-progress-bar/circular-progress-bar.component.scss */
:host {
  display: block;
}
#progress {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  display: grid;
  place-items: center;
  float: left;
  position: relative;
}
#progress-value {
  background-color: #ffffff;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-weight: 600;
  font-size: 20px;
}
#image {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 65%;
  height: 65%;
  border-radius: 100%;
}
#image.animatedImage {
  transform: translate(-50%, -50%) scale(0);
  animation: bouncyZoomInWithSwing 1.5s ease-in-out 0.3s;
  animation-fill-mode: forwards;
}
#image.animatedImage:before {
  content: "";
  position: absolute;
  top: 0;
  left: -100px;
  width: 70px;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
  transform: skewX(-30deg);
  animation-name: slide;
  animation-duration: 7s;
  animation-timing-function: ease-in-out;
  animation-delay: 0.6s;
  animation-iteration-count: infinite;
  background:
    linear-gradient(
      to right,
      rgba(255, 255, 255, 0.13) 0%,
      rgba(255, 255, 255, 0.13) 77%,
      rgba(255, 255, 255, 0.5) 92%,
      rgba(255, 255, 255, 0) 100%);
}
@keyframes bouncyZoomInWithSwing {
  0% {
    transform: translate(-50%, -50%) scale(0) rotate(-10deg);
  }
  30% {
    transform: translate(-50%, -50%) scale(1.1) rotate(5deg);
  }
  70% {
    transform: translate(-50%, -50%) scale(0.9) rotate(-5deg);
  }
  100% {
    transform: translate(-50%, -50%) scale(1) rotate(0);
  }
}
@keyframes slide {
  0% {
    left: -100;
    top: 0;
  }
  50% {
    left: 120px;
    top: 0px;
  }
  100% {
    left: 290px;
    top: 0;
  }
}
#roundShape {
  width: 100%;
  height: 100%;
  position: absolute;
  transform: rotate(144deg);
}
#roundShape:after {
  content: "";
  background: var(--completed-color);
  position: absolute;
  top: 0;
  border-radius: 20px 20px 20px 20px;
  transform: translateX(-10px);
  left: 50%;
}
#roundShape.started:after {
  width: 20px;
  height: 20px;
}
/*# sourceMappingURL=circular-progress-bar.component-H7DKKTW3.css.map */
